import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { TenantAutoPayFailedNotificationSettings } from '~/swagger/settings/Api';

const TenantAutoPayFailedNotificationUrl = `${envConfig.service.settings}/company-portal/settings/tenantautopayfailednotification`;
const tenantAutoPayFailedNotificationCompanyUrl = `${TenantAutoPayFailedNotificationUrl}/company`;

export class tenantAutoPayFailedNotificationRepository extends BaseRestRepository {
  public async deleteTenantAutoPayFailedNotificationByLevel(level: string, levelId: string) {
    const url = `${TenantAutoPayFailedNotificationUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }

  public async getTenantAutoPayFailedNotificationAll() {
    const url = TenantAutoPayFailedNotificationUrl + '/with-overrides';
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getTenantAutoPayFailedNotification() {
    const url = tenantAutoPayFailedNotificationCompanyUrl;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateTenantAutoPayFailedNotification(payload: TenantAutoPayFailedNotificationSettings) {
    const url = tenantAutoPayFailedNotificationCompanyUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getTenantAutoPayFailedNotificationByLevel(level: string, levelId: string) {
    const url = `${TenantAutoPayFailedNotificationUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateTenantAutoPayFailedNotificationByLevel(
    level: string,
    levelId: string,
    payload: TenantAutoPayFailedNotificationSettings
  ) {
    const url = TenantAutoPayFailedNotificationUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }
}
